module.exports = __webpack_public_path__ + "img/type--2-spans--multiple-lang--fr.89c6a172.jpg";